import { makeStyles } from '@material-ui/core/styles'

export const materialStyles = makeStyles(theme => ({
  success: {
    backgroundColor: theme.palette.green.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}))
